import { GalleryDialogBannerOverlay } from './GalleryDialogBannerOverlay';
import { HorizontalAlignment, VerticalAlignment } from './types';
import { makeStyles } from '@material-ui/core';
import Cropper from 'cropperjs';
import React, { useMemo, useRef } from 'react';
import useSize from '@react-hook/size';

const useStyles = makeStyles({
    content: {
        height: ({ containerHeight }: { containerHeight: number }) => containerHeight,
        position: 'relative',
        width: '100%',
    },
    image: {
        height: '100%',
        width: '100%',
    },
    banner: {
        bottom: 0,
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
    },
});

export interface GalleryDialogPreviewProps {
    aspectRatio: number;
    src: string;
    text: string;
    horizontalAlignment: HorizontalAlignment;
    verticalAlignment: VerticalAlignment;
    color: string;
    imgRef: (ref: HTMLImageElement) => void;
    cropBoxData: Cropper.CropBoxData;
    zoom: number;
}

export const GalleryDialogPreview = (props: GalleryDialogPreviewProps) => {
    const containerRef = useRef<HTMLDivElement>();
    const [containerWidth] = useSize(containerRef);

    const containerHeight = useMemo(() => {
        return (containerWidth - 64) / 2 + 128;
    }, [containerWidth]);

    const classes = useStyles({ containerHeight });

    const shouldDisplayBannerOverlay = props.cropBoxData && props.text;

    return (
        <div ref={containerRef} className={classes.content}>
            <img ref={props.imgRef} className={classes.image} src={props.src} alt="" />
            <div className={classes.banner}>
                {shouldDisplayBannerOverlay && (
                    <GalleryDialogBannerOverlay
                        color={props.color}
                        horizontalAlignment={props.horizontalAlignment}
                        verticalAlignment={props.verticalAlignment}
                        text={props.text}
                        cropBoxData={props.cropBoxData}
                        zoom={props.zoom}
                    />
                )}
            </div>
        </div>
    );
};
